import styled from "styled-components";
import theme from "../../theme";

export const EbookFormSection = styled.div`
  .gravityform__field__input {
    width: 100%;
    background: ${theme.white};
  }
  .heading {
    margin-bottom: 13px;
    margin-top: 50px;
  }
  .subtitle {
    font-size: 18px !important;
    line-height: 30px;
    margin-bottom: 40px !important;
  }
  .formtitle {
    font-size: 24px !important;
    margin-bottom: 25px !important;
    // font-weight: 300;
  }
`;
export const FormHeading = styled.div`
  max-width: 505px;
  font-size: 44px !important;
  line-height: 57px !important;
  font-weight: 400 !important;
  margin: 0;
  color: ${theme.black};

  a {
    text-decoration: underline;
    color: ${theme.black};
    &:hover {
      color: ${theme.cyan};
      text-decoration: underline;
    }
  }

  @media (max-width: 890px) {
    font-weight: 400 !important;
    font-size: 35px !important;
    line-height: 40px !important;
  }
  @media (max-width: 768px) {
    font-weight: 400;
    font-size: 30px;
    line-height: 31px;
  }

  @media (max-width: 575px) {
    font-weight: 400;
    font-size: 24px !important;
    line-height: 31px !important;
  }
`;
